/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Sleep_WordsInputs */

const en_us2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sleep rest night`)
};

const pt_br2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sono dormir descanso noite`)
};

const es_419_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sueno dormir descanso noche`)
};

const pt_pt2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sono dormir descanso noite`)
};

const fr_fr2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sommeil dormir repos nuit`)
};

const de_de2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`schlaf schlafen erholung nacht`)
};

const it_it2_search_field_sleep_words = /** @type {(inputs: Search_Field_Sleep_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sonno dormire riposo notte`)
};

/**
* | output |
* | --- |
* | "sleep rest night" |
*
* @param {Search_Field_Sleep_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_sleep_words = /** @type {((inputs?: Search_Field_Sleep_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Sleep_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_sleep_words(inputs)
	if (locale === "es-419") return es_419_search_field_sleep_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_sleep_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_sleep_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_sleep_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_sleep_words(inputs)
	return en_us2_search_field_sleep_words(inputs)
});
export { search_field_sleep_words as "search.field_sleep_words" }